import { EventParentCategory, IEventParentCategory } from '../EventParentCategory/EventParentCategory';

export interface IEventCategory {
  id: string,
  name: string,
  description: string,
  createdAt: number|Date|null,
  parentCategoryId: string,
  parentCategory: IEventParentCategory|null,
}

export class EventCategory {

    public id: string;
    public name: string;
    public description: string;
    public createdAt: Date|null;
    public parentCategoryId: string;
    public parentCategory: EventParentCategory|null;

    constructor(data: IEventCategory) {
      this.id = data.id;
      this.name = data.name;
      this.description = data.description;
      this.createdAt = data.createdAt ? new Date(parseInt(`${data.createdAt}`, 10) * 1000) : null;
      this.parentCategoryId = data.parentCategoryId;
      this.parentCategory = data.parentCategory ? new EventParentCategory(data.parentCategory) : null;
    }
}

export const createNewEventCategory = (data: Partial<IEventCategory> = {}): EventCategory => new EventCategory({
  id: data.id || 'new',
  name: data.name || '',
  description: data.description || '',
  createdAt: data.createdAt || null,
  parentCategoryId: data.parentCategoryId || '',
  parentCategory: data.parentCategory || null,
});
